import { VueQueryPlugin } from '@tanstack/vue-query'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin(app => void app.vueApp.use(VueQueryPlugin))
